module.exports = __webpack_public_path__ + "img/githubuser.487357ea.png";